import styled from 'styled-components';
import { Typography } from '../../../../ui/Typography';

export const Container = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.tertiary};
`;
